import React from "react";
import { useNavigate, useLocation } from "react-router";
import orderBy from "lodash/orderBy";
import TextField from "@mui/material/TextField";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import useLabels from "../hooks/useLabels";
import useQueryParams from "../hooks/useQueryParams";
import InboundSummaryModal from "./InboundSummaryModal";

const formatInboundSummary = (shipmentItems = []) => {
  return orderBy(shipmentItems, v => v.shipment.shipmentId, "asc")
    .map(item => `${item.shipment.shipmentId} (${item.quantity})`)
    .join("\n");
};

export default function InboundSummary({ asset, disabled }) {
  const l = useLabels();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useQueryParams();
  const shipmentItems = asset?.shipmentItems || [];
  const hasItems = shipmentItems.length > 0;
  const isEditable = hasItems && !disabled;
  const currentAssetId = asset?.id ? String(asset.id) : null;
  const modalAssetId = params.get("inboundSummaryAssetId");
  const modalOpen = Boolean(currentAssetId && modalAssetId === currentAssetId);

  const updateModalRoute = isOpen => {
    if (!currentAssetId) {
      return;
    }

    const nextParams = new URLSearchParams(location.search);

    if (isOpen) {
      nextParams.set("inboundSummaryAssetId", currentAssetId);
    } else {
      nextParams.delete("inboundSummaryAssetId");
    }

    navigate({ pathname: location.pathname, search: nextParams.toString() });
  };

  const handleClick = () => {
    if (isEditable) {
      updateModalRoute(true);
    }
  };

  const handleCloseModal = () => {
    updateModalRoute(false);
  };

  return (
    <>
      <TextField
        multiline
        size="small"
        label={l.identifiers.receiving_report_number}
        value={formatInboundSummary(shipmentItems)}
        fullWidth
        disabled={disabled}
        InputProps={{
          endAdornment: isEditable ? (
            <Tooltip title="Click to view details">
              <InfoOutlinedIcon color="primary" fontSize="small" style={{ cursor: "pointer" }} />
            </Tooltip>
          ) : null,
          style: { cursor: isEditable ? "pointer" : "default" },
        }}
        onClick={handleClick}
      />
      {modalOpen && <InboundSummaryModal asset={asset} onClose={handleCloseModal} />}
    </>
  );
}
